<template lang="pug">
  .wt-stat-row.level.level-padding.is-mobile
    .level-left
      WtSvgIcon(:icon="icon" :width="iconWidth" :height="iconHeight").padding-right
      .padding-right.is-size-4 {{ name }}
    .level-right
      span.is-size-3.has-text-grey {{ value }}
</template>

<script>
import WtSvgIcon from "@@/WtSvgIcon/WtSvgIcon";

export default {
  name: "WtStatRow",

  components: {
    WtSvgIcon
  },

  props: {
    icon: {
      type: String,
      required: true
    },

    name: {
      type: String,
      required: true
    },

    value: {
      type: String,
      required: true
    },

    iconWidth: {
      type: String,
      default: "40px"
    },
    iconHeight: {
      type: String,
      default: "40px"
    }
  }
};
</script>

<style lang="sass" scoped>
.wt-stat-row
  .level-left
    flex-shrink: 1
  .level-padding
    padding: 7px 0
  .padding-right
    padding-right: 20px
</style>
